<template>
  <div class="zcxy">
    <div class="clearfix table-tools">
      <div class="buttons">
        <a-form layout='inline'>
          <a-form-item v-if="canSave">
            <a-button icon="plus" type="primary" @click="showEditModal()">新增商品</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div class="search">
        <a-form layout='inline' @submit="searchList">
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>商品名称</span>
              </template>
              <a-input allowClear v-model.trim="searchData.product_name" placeholder="商品名称" style="width: 200px"/>
            </a-tooltip>
          </a-form-item>
          <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>商品状态</span>
              </template>
              <a-select allowClear v-model="searchData.status" placeholder="请选择商品状态" style="width: 140px">
                <a-select-option v-for="(d, index) of productStatus" :key="index" :value="d['value']">{{ d['label'] }}</a-select-option>
              </a-select>
            </a-tooltip>
          </a-form-item>
          <!-- <a-form-item>
            <a-tooltip placement="topLeft" >
              <template slot="title">
                <span>是否参与红人推广计划</span>
              </template>
              <a-select allowClear v-model="searchData.product_com" placeholder="请选择是否参与红人推广计划" style="width: 140px">
                <a-select-option v-for="(d, index) of productCom" :key="index" :value="d['value']">{{ d['label'] }}</a-select-option>
              </a-select>
            </a-tooltip>
          </a-form-item> -->
          <a-form-item v-if="canIndex">
            <a-button type="primary" html-type="submit" @click="searchList">搜索</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="table">
      <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
      <a-table size="middle" :pagination="false" :bordered='false' rowKey="product_id"
        :columns="columns" :dataSource="list">
          <template slot="index" slot-scope="text, record , index">
            <span>{{(index+1) + pageParams.perPage * (pageParams.currentPage - 1)}}</span>
          </template>
          <template slot="image" slot-scope="text, record">
            <LImg :src="text" style="width: 44px; height: 44px;"/>
          </template>

            <template slot="status" slot-scope="text,record">
              <a-switch checkedChildren="售卖中" unCheckedChildren="已下架" :checked="record.status == '1'" @change="changeStatus(record)"/>
            </template>

          <template slot="action" slot-scope="text,record">
            <a v-if="canUpdate" href="javascript:;" @click="showEditModal(record)">编辑</a>
          </template>
      </a-table>
    </div>
    <div class="page">
      <a-pagination
        :pageSizeOptions="pageSizeOptions"
        :total="pageParams.totalCount"
        showSizeChanger
        :pageSize="pageParams.perPage"
        v-model="current"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
          :showTotal="total => `共 ${pageParams.totalCount.toLocaleString()}条 `"
      >
          <template slot='buildOptionText' slot-scope='props'>
            <span v-if="props.value!=='100'">{{props.value}}条/页</span>
            <span v-if="props.value==='100'">100条/页</span>
          </template>
        </a-pagination>
    </div>
    <editModal v-if="editVisible" :item="modalData"/>
  </div>
</template>

<script>
const columns = [
  { title: '#', width:'55px', scopedSlots: { customRender: 'index' }, key: 'index'},
  { title: '商品图', width: '60px', dataIndex: 'product_image', key: 'name',scopedSlots: { customRender: 'image' }, },
  { title: '商品名称', dataIndex: 'product_name', key: '1' },
  { title: '商品分类', dataIndex: 'cat_name', key: '2' },
  { title: '销售价格￥', dataIndex: 'sale_price', key: '3' ,align:"center"},
  { title: '市场价￥', dataIndex: 'market_price', key: '4' ,align:"center"},
  { title: '浏览次数', dataIndex: 'product_readi', key: '5' ,align:"center"},
  { title: '销量', dataIndex: 'sale_count', key: '6' ,align:"center"},
  { title: '库存', dataIndex: 'product_instocks', key: '7' ,align:"center"},
  { title: '添加时间', dataIndex: 'created_at', key: '8' ,align:"right"},
  { title: '商品状态', dataIndex: 'status', key: '9' , scopedSlots: { customRender: 'status' } ,align:"right"},
  { title: '操作', key: 'operation', width: 60, align: 'right', scopedSlots: { customRender: 'action' }},
]

import C_ITEMS from '@/utils/items'
import editModal from './editModal'
import authority from '@/common/mixins/authority'
import tableMixins from '@/common/mixins/table'
export default {
  name: 'gjjl',
  provide() {
    return {
      parent: this
    }
  },

  components: {
    editModal,
  },

  data() {
    return {
      loading: false,
      pageSizeOptions: ['10', '20', '30', '40', '100'],
      current: 1,
      pageParams: {
        currentPage: 1,
        pageCount: 50,
        perPage: 10,
        totalCount: 0
      },
      columns,
      searchParams: {
        "page": 1,
        "per-page": 10,
        "search": {},
        "sort": ''
      },
      list: [],
      current: 1,

      productStatus: C_ITEMS.productStatus,
      productCom: C_ITEMS.productCom,

      searchData: {},

      visible: false,
      modalData: {},
      editVisible: false,
      authType:['market','store'],
    }
  },
  mixins: [ authority, tableMixins ],

  methods: {
    closeSearch() {
      this.visible = false
    },
    async getList() {
      if(!this.canIndex){
          this.$message.warning('您暂无权限!!')
          return false
      }
      this.loading = true
      let obj = {}
      let { searchData } = this
      if (searchData) {
        for (let k in searchData) {
          obj[k] = searchData[k]
        }
      }
      this.searchParams.search = obj
      let res = await this.$store.dispatch('storeProductAction', { data: this.searchParams })
      this.list = res.items
      this.pageParams = res._meta
      this.loading = false
    },
    showEditModal(item) {
      this.modalData = item
      this.editVisible = true
    },
    hideEditModal(type) {
      if (type === 1) {
        this.getList()
      }
      this.editVisible = false
    },


    changeStatus(record) {
      if (record.check_status == '1') {
        this.deleteItem(record)
      } else {
        this.recoveryItem(record)
      }
    },
    deleteItem(item) {
      let that = this
      this.$confirm({
        title: `您确定要下架"${item.product_name}"吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('storeProductDeleteAction', { data: { product_id: item.product_id } })
            if (res) {
              that.getList()
              resolve(res)
            }
          }).catch(error => console.log(error))
        }
      })
    },
    recoveryItem(item) {
      let that = this
      this.$confirm({
        title: `您确定要上架"${item.student_name}"吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('storeProductRecoveryAction', { data: { product_id: item.product_id } })
            if (res) {
              that.getList()
              resolve(res)
            }
          }).catch(error => console.log(error))
        }
      })
    },
  }
}
</script>
